import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Heart: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M 12.002 21.255 C 11.795 21.255 11.607 21.171 11.471 21.035 L 3.221 12.785 C 2.172 11.723 1.523 10.263 1.523 8.651 C 1.523 5.402 4.157 2.769 7.406 2.769 C 9.019 2.769 10.481 3.418 11.543 4.47 L 12.001 4.928 L 12.459 4.47 C 13.524 3.406 14.994 2.749 16.619 2.749 C 18.243 2.749 19.713 3.407 20.778 4.47 C 21.841 5.535 22.498 7.005 22.498 8.628 C 22.498 10.252 21.841 11.722 20.778 12.787 L 12.532 21.037 C 12.396 21.172 12.209 21.255 12.003 21.255 C 12.002 21.255 12.002 21.255 12.002 21.255 Z" />
  </SvgIcon>
);
